import {connect} from "react-redux"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import getMyAccountQuicklinks from "../../utils/getMyAccountQuicklinks"
import {SupportedRegionTypes, SupportedRegionSubTypes} from "../../models/regions"
import urls from "../../config/urls"
import {State} from "../../ducks"
import {updateUserStatus} from "../../ducks/user"

export const mapStateToProps = (state: State) => {
    const {
        user: {firstName, userUpdated, loggedIn},
        data,
        request: {siteUrl, cleanSiteUrl},
        text: {myAccount},
        settings: {variant, iconsVersionPath, showCheckoutButton, isTpSuperLite},
    } = state

    const realm = data?.realm || ""
    const isLoggedIn = loggedIn

    const quickLinks = data?.regions
        ?.filter(region => region.type === SupportedRegionTypes.QuickLinks)[0]
        ?.elements?.filter(link => link.type === SupportedRegionSubTypes.MyAccount)[0].elements

    const myAccountLinks = getMyAccountQuicklinks(quickLinks, isLoggedIn, userUpdated, firstName)
    const {accessibilityText, myAccountText, wideModeIcon, narrowModeIcon} = myAccountLinks

    return {
        accessibilityText,
        isLoggedIn: state.user.loggedIn,
        narrowModeIcon: formatCdnPathWithVariant(narrowModeIcon || "", realm, variant, iconsVersionPath),
        signoutUrl: `${isTpSuperLite ? cleanSiteUrl : siteUrl}${urls.myAccount.signoutUrl}`,
        tooltipIcon: urls.myAccount.tooltipIconUrl(realm, variant, iconsVersionPath),
        url: `${isTpSuperLite ? cleanSiteUrl : siteUrl}${urls.myAccount.loginUrl}`,
        myAccountText,
        wideModeIcon: formatCdnPathWithVariant(wideModeIcon || "", realm, variant, iconsVersionPath),
        firstName,
        userUpdated,
        text: myAccount,
        showCheckoutButton,
    }
}

export const mapDispatchToProps = dispatch => ({
    updateShoppingBag: (data: any) => {
        dispatch(updateUserStatus(data))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
